/*用户状态*/
import { setLocalStorage, getLocalStorage } from '@/utils/base'

const user = {

  namespaced: true,

  /*状态值*/
  state: {
    menber: null,
    printLanguage: '' || getLocalStorage('printLanguage') || 'chinese'
  },

  /*状态值转换*/
  getters: {

    getmenber: (state) => (name) => {
      return state.menber;
    },

  },

  /*改变状态的方法 不可异步*/
  mutations: {

    setMenber(state, value) {
      state.menber = value;
    },
    // 设置打印语言
    setPrintLanguage(state,value){
      state.printLanguage = value;
      setLocalStorage('printLanguage',value)
    },
  },
}


export default user;



// WEBPACK FOOTER //
// ./src/store/user/index.js